import React from "react";

const Index = (props: any) => {
  return (
    <div>
      {props.children}
    </div>
  );
};

export default Index;
